import { render, staticRenderFns } from "./swipe-item.vue?vue&type=template&id=a79f30f0&"
import script from "./swipe-item.vue?vue&type=script&lang=js&"
export * from "./swipe-item.vue?vue&type=script&lang=js&"
import style0 from "./swipe-item.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "swipe-item.vue"
export default component.exports